<template>
    <div class="xdeerrtts">
        <img src="../assets/img/bhjhhse.png" class="w100 dfgyuxeru">
        <div class="pd sdfdgdfteeryert">
            <div class="bgff yj4   pt20 pr">
                <p class="cen">
                    <span class="fz16 z3 pr f_b jjnndsrtywe">注册会员</span>
                </p>
                <div class="cen">
                    <p class="kkmmseer f_b">
                        注册长期电子会员卡，可多次检票入园
                    </p>
                </div>
                <div class="mt10">
                    <van-field placeholder="请输入姓名" clearable v-model="input.name" :rules="[{ required: true }]">
                        <template slot="label">
                            <i class="f_i jjnnjxer cz"></i>
                            <span class="ml10 cz">姓 名</span>
                        </template>
                    </van-field>
                    <van-field placeholder="请输手机号" clearable v-model="input.mobile" :rules="[{ required: true }]">
                        <template slot="label">
                            <i class="f_i jjnnjxer cz ag"></i>
                            <span class="ml10 cz">手机号</span>
                        </template>
                    </van-field>
                    <van-field placeholder="请输身份证" clearable v-model="input.idCard" :rules="[{ required: true }]">
                        <template slot="label">
                            <i class="f_i jjnnjxer cz ae"></i>
                            <span class="ml10 cz">身份证</span>
                        </template>
                    </van-field>
                    <van-cell :value="input.education||'请选择学历'" :value-class="input.education?'z3':''" is-link @click="showCs=true">
                        <template #title>
                            <i class="f_i jjnnjxer cz ah"></i>
                            <span class="ml10 cz">学 历</span>
                        </template>
                    </van-cell>

                    <van-field name="radio" label="单选框">
                        <template slot="label">
                            <i class="f_i jjnnjxer cz ai"></i>
                            <span class="ml10 cz">性 别</span>
                        </template>
                        <template #input>
                            <van-radio-group icon-size="16px" checked-color="#A9716D" v-model="input.sex" direction="horizontal" class="fz12">
                                <van-radio name="男">男</van-radio>
                                <van-radio name="女">女</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-cell :value="input.nation||'请选择民族'" is-link  :value-class="input.nation?'z3':''" @click="showCsb=true">
                        <template #title>
                            <i class="f_i jjnnjxer cz ab"></i>
                            <span class="ml10 cz">民 族</span>
                        </template>
                    </van-cell>
                    <van-field placeholder="请输入居住地址" clearable v-model="input.address" :rules="[{ required: true }]">
                        <template slot="label">
                            <i class="f_i jjnnjxer cz aj"></i>
                            <span class="ml10 cz">住 址</span>
                        </template>
                    </van-field>
                    <div class="mt30">
                        <van-button type="primary" class="w100 fdyyuweert" @click="onClick">提交</van-button>
                    </div>
                </div>

            </div>
        </div>
        <van-action-sheet v-model="showCs" :actions="educations[0].children" @select="onSelect" />
        <van-action-sheet v-model="showCsb" :actions="nations[0].children" @select="onSelectb" />
    </div>
</template>

<script>
import IdcardField from "@/components/IdCardField.vue";
import PickerField from "@/components/PickerField.vue";
import memberService from "@/services/memberService.js";
import commonService from "@/services/commonService.js";
import validate from "@/utils/validator.js";
import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("memberModule");

export default {
  components: {
    IdcardField,
    PickerField
  },
  data() {
    return {
      showCs: false,
      showCsb: false,
      loading: false,
      input: {
        name: "",
        mobile: "",
        idCard: "",
        sex: "",
        nation: "",
        education: "",
        address: ""
      },
      educations: [{ text: "学历", children: [] }],
      nations: [{ text: "民族", children: [] }]
    };
  },
  methods: {
    onSelect(e) {
        this.input.education = e.value
        this.showCs = false
    },
    onSelectb(e) {
        this.input.nation = e.value
        this.showCsb = false
    },
    async onClick() {
      let validateRules = [
        {
          value: this.input.name,
          name: "姓名",
          rules: [
            {
              rule: "required"
            }
          ]
        },
        {
          value: this.input.mobile,
          name: "手机号码",
          rules: [
            {
              rule: "required"
            },
            {
              rule: "isMobile"
            }
          ]
        },
        {
          value: this.input.idCard,
          name: "身份证",
          rules: [
            {
              rule: "required"
            },
            {
              rule: "isIdCard"
            }
          ]
        }
      ];
      let result = validate(validateRules);
      if (!result.success) {
        this.$toast(result.message);
        return;
      }

      try {
        this.loading = true;
        let response = await memberService.registMemberCardAsync(this.input);
        if (response.success) {
          this.registMemberCard();
          this.$router.replace("/membercard");
        }
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    },
    ...mapMutations(["registMemberCard"])
  },
  created() {
    commonService.getEducationComboboxItems().then(items => {
      let pickerItems = items.map(item => {
        return { value: item.value, name: item.displayText };
      });
      this.educations = [{ text: "学历", children: pickerItems }];
    });

    commonService.getNationComboboxItems().then(items => {
      let pickerItems = items.map(item => {
        return { value: item.value, name: item.displayText };
      });
      this.nations = [{ text: "民族", children: pickerItems }];
    });
  }
};
</script>

<style scoped>
    .kkmmseer{
        font-size: 13px;
        color: #a9716d;
        background-color: #F2EDE9;
        padding: 2px 14px;
        border-radius: 4px;
        margin-top: 10px;
    }

</style>
